<p-card>
  <ng-template pTemplate="header">
    <h3 style="margin: 0; padding: 1rem;">Job Activity Audit Log</h3>
  </ng-template>
  
  <p-table 
    [value]="auditLogs" 
    [loading]="loading"
    [responsive]="true" 
    [sortField]="'ActivityDateTime'"
    [sortOrder]="-1"
    styleClass="p-datatable-sm">
    
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ActivityDateTime">
          Date/Time
        </th>
        <th>Performed By</th>
        <th>Activity</th>
      </tr>
    </ng-template>
    
    <ng-template pTemplate="body" let-auditLog>
      <tr>
        <td>
          <small>{{ formatDateTime(auditLog.ActivityDateTime) }}</small>
        </td>
        <td>
          {{ getUserFullName(auditLog) }}
        </td>
        <td>
          <div class="audit-comment">
            {{ auditLog.Comment }}
          </div>
        </td>
      </tr>
    </ng-template>
    
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center">
          No audit logs found for this job.
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
